import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  CInventoryTransactions,
  InventoryTransaction,
} from '@app/core/_constant/inventory-transaction.constant';
import { IRfqQtyLogs } from '@app/core/inventory/store/inventory.model';

@Component({
  selector: 'cnc-sku-log-detail-remarks',
  templateUrl: './sku-log-detail-remarks.component.html',
  styleUrls: ['./sku-log-detail-remarks.component.scss'],
})
export class SkuLogDetailRemarksComponent implements OnInit {
  @Input()
  log :IRfqQtyLogs;
  datePipe :DatePipe = new DatePipe('en');
  eInventoryTransaction :typeof InventoryTransaction = InventoryTransaction;
  cInventoryTransactions :typeof CInventoryTransactions = CInventoryTransactions;

  constructor(
    private router :Router,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.loadRemarks();
  }

  private loadRemarks() :void {
    const inventoryTransactionData = this.cInventoryTransactions.filter(
      (inventoryTransaction) => inventoryTransaction.value === this.log.transaction,
    );
    this.log.remarks = '';
    this.log.channelLabel = '';
    inventoryTransactionData.forEach((data) => {
      this.log.isClickableRemarks = data.isClickableRemarks;
      this.log.isformattableDetails = data.formattableDetails;
      if (data.formattableDetails && this.log.details !== '[]') {
        this.processFormattableRemarks();
      } else if (
        (!data.formattableDetails && data.isClickableRemarks) ||
        (data.formattableDetails && this.log.details === '[]')
      ) {
        this.processUnformattableClickableRemarks();
      }

      if (this.log?.order && !this.log?.order?.channel_id) {
        this.log.channelLabel = data.formattableDetails ? 'Luminous Invoice' : '';
      } else if (this.log?.order && this.log?.order?.order_channel) {
        this.log.channelLabel = data.formattableDetails
          ? this.log.order?.order_channel?.label
          : '';
      }
    });
  }

  private processFormattableRemarks() :void {
    try {
      const rowDetails = JSON.parse(this.log.details);
      let linkTransactionNumber :number = 0;
      if (typeof rowDetails === 'object' && Object.keys(rowDetails).length > 0) {
        if (rowDetails.orderNumber) {
          if (this.log.transaction === this.eInventoryTransaction.PICK_AUTO) {
            linkTransactionNumber = rowDetails.orderNumber;
            this.log.remarks = this.formatDetailsByOrderNumber(
              rowDetails.orderNumber,
              rowDetails.source,
              rowDetails.orderDate.date,
            );
          } else {
            linkTransactionNumber = rowDetails.orderId;
            this.log.remarks = this.formatDetailsByOrderNumber(
              rowDetails.orderNumber,
              rowDetails.source,
              rowDetails.orderDate,
            );
          }
        } else if (rowDetails.referenceNumber) {
          if (this.log.transaction === this.eInventoryTransaction.FULFILLMENT_ORDER) {
            linkTransactionNumber = this.log.transactionId;
          } else {
            linkTransactionNumber = rowDetails.referenceNumber;
          }
          this.log.remarks = this.formatDetailsByReferenceNumber(rowDetails);
        }

        //Set Remark Link
        this.log.remarkLink = this.setRemarksUrlLink(
          this.log?.transaction,
          linkTransactionNumber,
          this.log?.isformattableDetails,
        );
      } else {
        this.log.remarks = this.log.details;
      }
    } catch (_) {}
  }

  private processUnformattableClickableRemarks() :void {
    if (this.log?.transaction == 'IMPORT QUANTITIES') {
      this.log.remarks = '';

      return;
    }
    if (!this.log?.order) {
      this.log.remarks = '';

      return;
    }
    this.log.remarks = this.formatDetailsByOrderNumber(
      this.log?.order?.orderNumber,
      this.log?.order?.source,
      this.log?.order?.orderDate,
    );
    //Set Remark Link
    const linkTransactionNumber =
      this.log?.transaction &&
      this.log?.transaction === this.eInventoryTransaction.PICK_AUTO
        ? this.log?.order?.orderNumber
        : this.log?.order?.orderId;
    this.log.remarkLink = this.setRemarksUrlLink(
      this.log?.transaction,
      linkTransactionNumber,
      this.log?.isformattableDetails,
    );
  }

  private processTransferLogLink() :string {
    if (this.log.locationId !== this.log.transferLog.source_location_id) {
      return '/locations/s/' + this.log.transferLog.source_location_id + '/logs';
    } else if (
      this.log.locationId !== this.log.transferLog.destination_location_id
    ) {
      return (
        '/locations/s/' + this.log.transferLog.destination_location_id + '/logs'
      );
    }

    return '';
  }

  private formatDetailsByOrderNumber(
    orderNumber :string,
    source :string,
    orderDate :Date,
  ) {
    return (
      orderNumber +
      ' [' +
      source +
      '] ' +
      'Order Date: ' +
      this.datePipe.transform(orderDate, 'mediumDate')
    );
  }

  private formatDetailsByReferenceNumber(rowDetails :any) :string {
    let remarks = '';
    if (rowDetails.remarks) {
      remarks = ' ' + rowDetails.remarks;
    }
    if (!rowDetails.referenceNumber) {
      return '';
    }

    return (
      rowDetails.referenceNumberLabel +
      ': ' +
      rowDetails.referenceNumber +
      ' ' +
      rowDetails.transactionDateLabel +
      ': ' +
      this.datePipe.transform(rowDetails.transactionDate, 'mediumDate') +
      remarks
    );
  }

  private setRemarksUrlLink(
    transaction :string,
    linkTransactionNumber :number | string,
    isFormattableDetails :boolean,
  ) :string {
    switch (transaction) {
      case this.eInventoryTransaction.PICKLIST:
        return `/shipping/picklists/${linkTransactionNumber}`;

      case this.eInventoryTransaction.PURCHASE_ORDER:
        return `/orders?poNumber=${linkTransactionNumber}`;

      case this.eInventoryTransaction.TRANSFER_ORDER:
        return `/inventory/transfer-order/${linkTransactionNumber}`;

      case this.eInventoryTransaction.SKU_LOCATION_TRANSFER:
        if (this.log?.transferLog) {
          return this.processTransferLogLink();
        }
        break;

      case this.eInventoryTransaction.SALES_ORDER:
      case this.eInventoryTransaction.PICK_AUTO:
        return `/shipping/posted-orders?orderNumber=${linkTransactionNumber}`;

      case this.eInventoryTransaction.FULFILLMENT_ORDER:
        return `/shipping/fulfillment-order/${linkTransactionNumber}`;
    }

    if (!isFormattableDetails) {
      return `/shipping/posted-orders?orderId=${linkTransactionNumber}`;
    }

    return '';
  }
}
